export const seedOrders = [
  {
    id: 1,
    customer: "Emily Morgan",
    initials: "EM",
    product: "Country Sourdough",
    quantity: 2,
    total: 26,
    status: "Paid",
    due: "Today",
    accent: "sage",
    notes: "",
    isSample: true,
  },
  {
    id: 2,
    customer: "James Walker",
    initials: "JW",
    product: "Whole Wheat",
    quantity: 2,
    total: 24,
    status: "Paid",
    due: "Today",
    accent: "sand",
    notes: "",
    isSample: true,
  },
  {
    id: 3,
    customer: "Sophie Lee",
    initials: "SL",
    product: "Seeded Sourdough",
    quantity: 4,
    total: 54,
    status: "Paid",
    due: "Today",
    accent: "terracotta",
    notes: "",
    isSample: true,
  },
  {
    id: 4,
    customer: "Maya Patel",
    initials: "MP",
    product: "Country Sourdough",
    quantity: 1,
    total: 13,
    status: "New",
    due: "Tomorrow",
    accent: "plum",
    notes: "",
    isSample: true,
  },
  {
    id: 5,
    customer: "Avery Brooks",
    initials: "AB",
    product: "Cheddar Jalapeño",
    quantity: 2,
    total: 30,
    status: "Deposit",
    due: "Saturday",
    accent: "ink",
    notes: "",
    isSample: true,
  },
];

export const recipes = [
  {
    id: "country",
    name: "Country Sourdough",
    note: "Open crumb · everyday loaf",
    yield: 8,
    hydration: 75,
    price: 13,
    ingredients: [
      { name: "Bread flour", weight: 4000, percent: 80 },
      { name: "Whole wheat", weight: 1000, percent: 20 },
      { name: "Water", weight: 3750, percent: 75 },
      { name: "Starter", weight: 1000, percent: 20 },
      { name: "Salt", weight: 100, percent: 2 },
    ],
  },
  {
    id: "whole-wheat",
    name: "Whole Wheat",
    note: "Nutty · hearty · 40% whole grain",
    yield: 6,
    hydration: 78,
    price: 12,
    ingredients: [
      { name: "Bread flour", weight: 2250, percent: 60 },
      { name: "Whole wheat", weight: 1500, percent: 40 },
      { name: "Water", weight: 2925, percent: 78 },
      { name: "Starter", weight: 750, percent: 20 },
      { name: "Salt", weight: 75, percent: 2 },
    ],
  },
  {
    id: "seeded",
    name: "Seeded Sourdough",
    note: "Sesame · sunflower · flax",
    yield: 8,
    hydration: 77,
    price: 13.5,
    ingredients: [
      { name: "Bread flour", weight: 4000, percent: 80 },
      { name: "Whole wheat", weight: 1000, percent: 20 },
      { name: "Water", weight: 3850, percent: 77 },
      { name: "Starter", weight: 1000, percent: 20 },
      { name: "Salt", weight: 100, percent: 2 },
      { name: "Seed soaker", weight: 600, percent: 12 },
    ],
  },
  {
    id: "jalapeno",
    name: "Cheddar Jalapeño",
    note: "Sharp cheddar · gentle heat",
    yield: 4,
    hydration: 72,
    price: 15,
    ingredients: [
      { name: "Bread flour", weight: 2200, percent: 100 },
      { name: "Water", weight: 1584, percent: 72 },
      { name: "Starter", weight: 440, percent: 20 },
      { name: "Salt", weight: 44, percent: 2 },
      { name: "Cheddar", weight: 440, percent: 20 },
      { name: "Jalapeño", weight: 132, percent: 6 },
    ],
  },
  {
    id: "chocolate-cake",
    name: "Chocolate Snack Cake",
    note: "Cocoa · soft crumb · simple square",
    productType: "cake",
    formulaMode: "bakers",
    yield: 1,
    unitName: "cake",
    hydration: 95,
    price: 24,
    salesOptions: [
      { id: "whole-cake", label: "Whole cake", units: 1, price: 24, capacityUnits: 2 },
      { id: "half-cake", label: "Half cake", units: 0.5, price: 14, capacityUnits: 1 },
    ],
    ingredients: [
      { name: "All-purpose flour", category: "flour", flourType: "All-purpose flour", weight: 320, percent: 100 },
      { name: "Sugar", category: "sweetener", weight: 272, percent: 85 },
      { name: "Cocoa powder", category: "inclusion", weight: 80, percent: 25 },
      { name: "Milk", category: "liquid", weight: 192, percent: 60 },
      { name: "Eggs", category: "liquid", weight: 128, percent: 40 },
      { name: "Oil", category: "fat", weight: 112, percent: 35 },
      { name: "Salt", category: "salt", weight: 5, percent: 1.5 },
    ],
  },
  {
    id: "fireweed-hot-sauce",
    name: "Fireweed Hot Sauce",
    note: "Peppery · tangy · small bottle",
    productType: "hot_sauce",
    formulaMode: "batch",
    yield: 6,
    unitName: "bottle",
    hydration: 30,
    price: 9,
    salesOptions: [
      { id: "single-bottle", label: "Bottle", units: 1, price: 9, capacityUnits: 1 },
      { id: "three-pack", label: "Three-pack", units: 3, price: 24, capacityUnits: 1 },
    ],
    baseWeight: 1200,
    flourWeight: 1200,
    ingredients: [
      { name: "Chiles / peppers", category: "produce", weight: 660, percent: 55 },
      { name: "Vinegar", category: "acid", weight: 360, percent: 30 },
      { name: "Garlic", category: "spice", weight: 60, percent: 5 },
      { name: "Honey", category: "sweetener", weight: 84, percent: 7 },
      { name: "Salt", category: "salt", weight: 36, percent: 3 },
    ],
  },
  {
    id: "herb-infused-oil",
    name: "Herb Infused Oil",
    note: "Olive oil · herbs · garlic",
    productType: "infused_oil",
    formulaMode: "batch",
    yield: 4,
    unitName: "bottle",
    hydration: 0,
    price: 12,
    salesOptions: [
      { id: "single-bottle", label: "Bottle", units: 1, price: 12, capacityUnits: 1 },
      { id: "half-dozen", label: "Half dozen", units: 6, price: 66, capacityUnits: 1 },
    ],
    baseWeight: 1000,
    flourWeight: 1000,
    ingredients: [
      { name: "Olive oil", category: "fat", weight: 920, percent: 92 },
      { name: "Herbs, chiles, or garlic", category: "spice", weight: 80, percent: 8 },
    ],
  },
];

export const seedInventory = [
  { id: "inventory-bread-flour", name: "Bread flour", amount: 18.4, unit: "kg", target: 12, unitCost: 1.65 },
  { id: "inventory-whole-wheat", name: "Whole wheat", amount: 4.2, unit: "kg", target: 5, unitCost: 2.1 },
  { id: "inventory-sea-salt", name: "Sea salt", amount: 1.7, unit: "kg", target: 0.8, unitCost: 3.25 },
  { id: "inventory-paper-bags", name: "Paper bags", amount: 14, unit: "each", target: 24, unitCost: 0.32 },
];

export const seedExpenses = [];

export const seedStarters = [
  {
    id: "mabel",
    name: "Mabel",
    hydration: 100,
    flourBlend: [
      { type: "Bread flour", percent: 70 },
      { type: "Whole wheat", percent: 30 },
    ],
    notes: "Reliable house starter with a mild, wheaty aroma.",
  },
];

export const scheduleSeed = [
  { id: "feed", label: "Feed starter", time: "06:00", day: "Friday" },
  { id: "mix", label: "Mix dough", time: "06:30", day: "Saturday" },
  { id: "folds", label: "Folds", time: "07:00", endTime: "09:00", day: "" },
  { id: "shape", label: "Shape", time: "11:45", day: "" },
  { id: "proof", label: "Cold proof", time: "12:15", day: "" },
  { id: "bake", label: "Bake", time: "16:30", day: "" },
];
